module.exports = __webpack_public_path__ + "img/terms-and-conditions.46682043.png";